import { render, staticRenderFns } from "./event_schedule2.vue?vue&type=template&id=f4e5903e&"
import script from "./event_schedule2.vue?vue&type=script&lang=js&"
export * from "./event_schedule2.vue?vue&type=script&lang=js&"
import style0 from "./event_schedule2.vue?vue&type=style&index=0&id=f4e5903e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports